export default __webpack_public_path__ + "static/media/story8.85266407.jpg";